module.exports = __webpack_public_path__ + "img/komship-logo.81ab3253.svg";